import { Card, CardBody, Chip } from '@heroui/react'
import { DollarSign, Gift, Users, GitBranch, Package } from 'lucide-react'
import type { AlertCategoryInfo, AlertCategory } from '../../types'

interface AlertCategoriesProps {
  categories: AlertCategoryInfo[]
  selectedCategory: AlertCategory | null
  onSelectCategory: (category: AlertCategory | null) => void
}

function getCategoryIcon(id: AlertCategory) {
  switch (id) {
    case 'pricing_strategy': return <DollarSign className="w-5 h-5" />
    case 'free_gifts_boosters': return <Gift className="w-5 h-5" />
    case 'lead_generation': return <Users className="w-5 h-5" />
    case 'funnel_structure': return <GitBranch className="w-5 h-5" />
    case 'inventory_stock': return <Package className="w-5 h-5" />
  }
}

export function AlertCategories({ categories, selectedCategory, onSelectCategory }: AlertCategoriesProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
      {categories.map((cat) => {
        const isSelected = selectedCategory === cat.id
        return (
          <Card
            key={cat.id}
            isPressable
            className={`border transition-colors ${isSelected ? 'border-primary bg-primary-50' : 'border-default-200 hover:border-primary-200'}`}
            onPress={() => onSelectCategory(isSelected ? null : cat.id)}
          >
            <CardBody className="p-3">
              <div className="flex items-center gap-2 mb-2">
                <span className={isSelected ? 'text-primary' : 'text-default-500'}>
                  {getCategoryIcon(cat.id)}
                </span>
                <span className="text-sm font-semibold text-foreground">{cat.name}</span>
              </div>
              <p className="text-xs text-default-500 mb-2 line-clamp-2">{cat.description}</p>
              <div className="flex items-center gap-2">
                <Chip size="sm" variant="flat">{cat.templateCount} templates</Chip>
                <Chip size="sm" variant="flat" color="success">{cat.activeCount} active</Chip>
              </div>
            </CardBody>
          </Card>
        )
      })}
    </div>
  )
}
